/* eslint-disable no-console */

if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js', {
            ready() {
                console.log(
                    'App is being served from cache by a service worker.\n' +
                    'For more details, visit https://goo.gl/AFskqB'
                )
            },
            registered() {
                console.log('Service worker has been registered.')
            },
            cached() {
                console.log('Content has been cached for offline use.')
            },
            updatefound() {
                console.log('New content is downloading.')
            },
            updated(content) {
                console.log(content)
            },
            offline() {
                console.log('No internet connection found. App is running in offline mode.')
            },
            error(error) {
                console.error('Error during service worker registration:', error)
            }
        })
            .then((registration) => {
                console.log('ServiceWorker registration successful with scope: ', registration.scope);
            })
            .catch((error) => {
                console.log('ServiceWorker registration failed: ', error);
            });
    });
}
